import React from 'react';
import core, { App } from '@gin-betting/core';
import { floor } from 'lodash';

import Fractional from 'components/Fractional';

const { formatDecimalOdd: fDecimalOdd } = core.utils;

type Value = ReturnType<typeof fDecimalOdd>;

const formatDecimalOdd = (
    ...args: Parameters<typeof fDecimalOdd>
): {
    value: Value;
    component: JSX.Element | Value;
} => {
    const [coef, oddFormat] = args;

    let value: Value = floor(+coef, 2);

    const result: ReturnType<typeof formatDecimalOdd> = {
        value,
        component: value,
    };

    value = fDecimalOdd(coef, oddFormat);
    result.value = value;
    result.component = value;

    if (oddFormat === App.OddFormat.Fractional) {
        result.component = React.createElement(Fractional, {
            value: value as string,
        });
    }

    return result;
};

export default formatDecimalOdd;
